<template>
  <div>
    <ValidationObserver v-slot="{ handleSubmit }" ref="form">
      <form class="form" id="area_create" @submit.prevent="handleSubmit(handleWorkCoordination)">
        <span class="d-block mt-3 mb-4">
          Vui lòng chọn người phụ trách để chuyển người phụ trách cho {{ requestSelectedList.length }} yêu cầu trên.
        </span>
        <ValidationProvider vid="name" name="Người phụ trách" rules="required" v-slot="{ errors }">
          <el-select v-model="personSelected" filterable clearable placeholder="Chọn người phụ trách" class="w-100">
            <el-option
              v-for="item in personInChargeOption"
              :key="item.id"
              :label="(item.id + 100000) + ' - ' + item.name"
              :value="item.id"
            />
          </el-select>
          <div class="fv-plugins-message-container">
            <div data-field="name" data-validator="notEmpty" class="fv-help-block">{{ errors[0] }}</div>
          </div>
        </ValidationProvider>
        <div class="d-flex justify-content-end mt-3">
          <button
            type="button"
            class="btn btn-secondary font-weight-bold mr-2"
            :disabled="submitLoading"
            @click="closeDialog"
          >
            Đóng
          </button>
          <button
            class="btn btn-primary font-weight-bold"
            type="submit"
            :disabled="submitLoading"
          >
            <i v-if="submitting" class="fas fa-spinner fa-spin mr-1"></i>
            {{ submitLoading ? "Đang lưu..." : "Gán tác vụ" }}
          </button>
        </div>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
import { GET_DEPARTMENT_IN_CHARGE } from "@/core/services/store/logistics/logistics.module";

export default {
  name: "DialogWorkCoordination",
  props: {
    listRequestSelected: {
      type: Array,
      required: true,
      default: () => [],
    },
    submitLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      personSelected: null,
      personInChargeOption: [],
      requestSelectedList: [],
    };
  },
  mounted() {
    this.getListPersonInChargeOption();
    this.getListIdRequestSelected();
  },
  methods: {
    closeDialog() {
      this.$emit("closeDialog");
    },
    getListPersonInChargeOption() {
      this.$store.dispatch(GET_DEPARTMENT_IN_CHARGE).then((res) => {
        if (!res.error) {
          this.personInChargeOption = res.data ?? [];
        }
      });
    },
    getListIdRequestSelected() {
      this.requestSelectedList = this.listRequestSelected.map((item) => item.id);
    },
    handleWorkCoordination() {
      this.$emit("submitWorkCoordination", {
        person_in_charge_id: this.personSelected,
        ids: this.requestSelectedList,
      });
    },
  },
};
</script>

<style scoped>
</style>
